import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import TrainingSection from "../components/Sections/TrainingSection/TrainingSection";

const Training = () => {
  return (
    <Layout>
      <Seo title="Training" description="Join Us and get trained from our industrial level experts." />
      <TrainingSection />
    </Layout>
  );
};

export default Training;
